import * as ActionTypes from './actionTypes';
import { SectionConfig, SubsectionConfig } from './reducer';

export interface UpdateSectionAction {
  type: typeof ActionTypes.UPDATE_SECTION
  payload: {
    sectionName: string
    subsectionName: string
  }
}

export const updateSection = (
  sectionName: string,
  subsectionName: string
): UpdateSectionAction => ({
  type: ActionTypes.UPDATE_SECTION,
  payload: {
    sectionName,
    subsectionName,
  },
});

export interface UpdateSectionSuccessAction {
  type: typeof ActionTypes.UPDATE_SECTION_SUCCESS
  payload: {
    section: SectionConfig
    subsection: SubsectionConfig
  }
}

export const updateSectionSuccess = (
  section: SectionConfig,
  subsection: SubsectionConfig
): UpdateSectionSuccessAction => ({
  type: ActionTypes.UPDATE_SECTION_SUCCESS,
  payload: {
    section,
    subsection,
  },
});

export interface UpdateSectionFailureAction {
  type: typeof ActionTypes.UPDATE_SECTION_FAILURE
  payload: {
    sectionName: string
    subsectionName: string
    error?: Error
  }
}

export const updateSectionFailure = (
  sectionName: string,
  subsectionName: string,
  error?: Error
): UpdateSectionFailureAction => ({
  type: ActionTypes.UPDATE_SECTION_FAILURE,
  payload: {
    sectionName,
    subsectionName,
    error,
  },
});

export type SectionActions =
  | UpdateSectionAction
  | UpdateSectionFailureAction
  | UpdateSectionSuccessAction
